import type { ReactNode } from 'react';
import { IconButton } from './IconButton.js';
import './Chip.css';

export interface ChipProps {
  children: ReactNode;
  /** Renders a remove control. `onRemove`'s accessible name includes the
   * chip's own text so a screen-reader user hears "Remove Salesforce", not a
   * bare "Remove" (a11y.md §5 — every control needs a descriptive name). */
  onRemove?: () => void;
  removeLabel?: string;
}

/** A filter/selection tag — distinct from `Badge` (a status indicator) and
 * `TierBadge`/`StateChip` (enum-value indicators): a Chip represents a
 * user-added, typically removable value (e.g. an applied filter). */
export function Chip({ children, onRemove, removeLabel }: ChipProps) {
  return (
    <span className="dpr-chip">
      <span className="dpr-chip__label">{children}</span>
      {onRemove ? (
        <IconButton
          label={removeLabel ?? `Remove ${typeof children === 'string' ? children : 'item'}`}
          icon={<span>×</span>}
          size="sm"
          variant="ghost"
          className="dpr-chip__remove"
          onClick={onRemove}
        />
      ) : null}
    </span>
  );
}
